import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useFilters, useOpportunities } from "./hooks";
import { getColumnWidth, onColumnResizeHof } from "./helpers";
import { Page } from "../../layouts/Page";
import {
  OpportunityListPageHeader,
  OpportunityLists
} from "../../molecules/OpportunitiesList";
import { BOTTOM_TABLE_COLUMNS, TOP_TABLE_COLUMNS } from "./constants";
import { OpportunitySidebar } from "../../molecules/OpportunitySidebar";

function Opportunities() {
  const [topColumnWidths, setTopColumnWidths] = useState(
    new Array(10).fill(null)
  );
  const [bottomColumnWidths, setBottomColumnWidths] = useState(
    new Array(10).fill(null)
  );
  const [isOpportunitySidebarOpen, setIsOpportunitySidebarOpen] = useState(
    false
  );
  const [opportunityId, setOpportunityId] = useState();
  const [shareOpportunity, setShareOpportunity] = useState(false);

  const onShareOpportunity = (opportunity) => {
    setOpportunityId(opportunity.id);
    setShareOpportunity(true);
    setIsOpportunitySidebarOpen(true);
  };

  const onDismiss = () => {
    setShareOpportunity(false);
    setIsOpportunitySidebarOpen(false);
  };

  const {
    filters,
    setFilters,
    filterOptions,
    loading: isFiltersLoading
  } = useFilters();

  const {
    loading: isOpportunitiesLoading,
    refetchOpportunities,
    activeOpportunities,
    inactiveOpportunities
  } = useOpportunities({ filters, onShareOpportunity });

  const resizeTopTablesColumns = onColumnResizeHof({
    columnWidths: topColumnWidths,
    setColumnWidths: setTopColumnWidths,
    columns: TOP_TABLE_COLUMNS
  });

  const resizeBottomTablesColumns = onColumnResizeHof({
    columnWidths: bottomColumnWidths,
    setColumnWidths: setBottomColumnWidths,
    columns: BOTTOM_TABLE_COLUMNS
  });


  const history = useHistory();

  return (
    <Page title="Your Opportunities" flex>
      <OpportunitySidebar
        filters={filters}
        sidebarIsOpen={isOpportunitySidebarOpen}
        onDismiss={() => onDismiss()}
        id={opportunityId}
        shareOpportunity={shareOpportunity}
      />

      <OpportunityListPageHeader
        filters={filters}
        setFilters={setFilters}
        filterOptions={filterOptions}
        onAddOpportunityPress={() => setIsOpportunitySidebarOpen(true)}
      />

      <OpportunityLists
        activeOpportunities={activeOpportunities}
        inactiveOpportunities={inactiveOpportunities}
        isLoading={isFiltersLoading || isOpportunitiesLoading}
        topColumns={TOP_TABLE_COLUMNS}
        bottomColumns={BOTTOM_TABLE_COLUMNS}
        topColumnWidths={topColumnWidths}
        bottomColumnWidths={bottomColumnWidths}
        getColumnWidth={getColumnWidth}
        onTopColumnResize={resizeTopTablesColumns}
        onBottomColumnResize={resizeBottomTablesColumns}
        onOpportunityClick={({ id }) => history.push(`/opportunities/${id}`)}
      />
    </Page>
  );
}

export default Opportunities;
